module.exports = __webpack_public_path__ + "img/slider-16.6d038770.jpg";